import { Link } from 'react-router-dom';

export default function ArticleEntry() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        <div className="w-full lg:w-[60%] flex flex-col">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-foreground-500 font-body">
            <span className="w-2 h-2 rounded-full bg-foreground-900 inline-block"></span>
            SEO Гид
          </span>

          <blockquote className="mt-6 font-heading text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground-900">
            <span className="text-5xl md:text-6xl">&ldquo;</span><br />
            Как экономить до 60%<br />
            с YOYBUY Sheet —<br />
            полное руководство
          </blockquote>

          <div className="mt-6 flex items-center gap-3">
            <span className="font-body text-sm font-semibold text-foreground-900 whitespace-nowrap">YOYBUY Team</span>
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-verified-badge-fill text-accent-500 text-sm"></i>
            </span>
            <span className="font-body text-sm text-foreground-500 whitespace-nowrap">Проверенный источник</span>
          </div>

          <Link
            to="/articles/yoybuy-spreadsheet-guide"
            className="mt-8 inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-800 rounded-full text-sm font-medium hover:bg-foreground-50 hover:border-foreground-400 transition-colors cursor-pointer whitespace-nowrap w-fit"
          >
            <span>Читать статью</span>
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="w-full lg:w-[40%]">
          <div className="w-full h-[400px] md:h-[500px] rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20portrait%20photography%20of%20modern%20minimalist%20fashion%20style%2C%20creative%20composition%20with%20clean%20white%20background%2C%20editorial%20aesthetic%2C%20high%20contrast%2C%20elegant%20and%20timeless%20mood%2C%20fine%20art%20photography%20with%20soft%20dramatic%20lighting&width=800&height=1100&seq=article-portrait&orientation=portrait"
              alt="YOYBUY Spreadsheet руководство"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}